import PdfSimpleViewer from "components/pdf-simple-viewer/pdf-simple-viewer";
import { Spin, message } from "antd";
import { useContext, useEffect, useState } from "react";
import { getFileDownloadURL } from "services/file-mgmt";
import useAuditEventLog from "entity-app/utils/export-audit-log";
import { ProjectContext, TProjectContext } from "context/ProjectProvider";

function SpecFileViewer(props: {
  fileKey: string;
  pageNumber: number;
  filename?: string;
  attachmentId?: string;
  /** featureType for audit log (design specifications module). */
  auditFeatureType?: string | null;
}) {
  const {
    fileKey,
    pageNumber,
    filename = "",
    attachmentId,
    auditFeatureType = "SPECIFICATIONS"
  } = props;

  const [fileUrl, setFileUrl] = useState("");
  const [loading, setloading] = useState(true);
  const { gqlClientForProject }: TProjectContext = useContext(ProjectContext);
  const { saveAuditLogEvent } = useAuditEventLog(gqlClientForProject);

  useEffect(() => {
    async function fetchData() {
      try {
        const fileDownloadURLResp: any = await getFileDownloadURL([fileKey]);
        setloading(false);
        if (fileDownloadURLResp.data) {
          const link = fileDownloadURLResp.data.success.urls[fileKey];
          setFileUrl(link);
          saveAuditLogEvent({
            eventType: "FILE_ATTACHMENT_VIEW",
            featureType: auditFeatureType,
            // fetchData is only called when fileKey is truthy (see the guard
            // below), so the trailing "" fallback of this chain is unreachable.
            /* v8 ignore next */
            filename: filename || fileKey || "",
            ...(attachmentId ? { attachmentId } : {})
          });
        }
      } catch (ex: any) {
        setloading(false);
        setFileUrl("");
        console.error("err: ", ex);
        const error: string =
          ex.response?.data?.error || ex.message || "Unable to fetch file";
        message.error(error);
      }
    }
    if (fileKey) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- log once per fileKey load
  }, [fileKey]);

  return (
    <div className="h-full">
      {!fileKey || !fileUrl || loading ? (
        <div className="h-full w-full flex items-center justify-center">
          <Spin size="large" />
        </div>
      ) : (
        <PdfSimpleViewer
          fileUrl={fileUrl}
          initialPage={pageNumber ? pageNumber - 1 : 0}
        />
      )}
    </div>
  );
}

export default SpecFileViewer;
